import { Location } from '../types';
import { CommonApi, CommonApiMethod } from '.';
const route = 'location';
const location: CommonApiMethod = new CommonApi<Location>(
  route,
  'Подразделения'
);

export default location;
